import { render, staticRenderFns } from "./QuickStartModal.vue?vue&type=template&id=7740d16d&"
import script from "./QuickStartModal.vue?vue&type=script&lang=js&"
export * from "./QuickStartModal.vue?vue&type=script&lang=js&"
import style0 from "./QuickStartModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* nuxt-component-imports */
installComponents(component, {Template: require('/lasso/components/templates/Template.vue').default,IconSelectProperty: require('/lasso/components/icons/IconSelectProperty.vue').default})


/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7740d16d')) {
      api.createRecord('7740d16d', component.options)
    } else {
      api.reload('7740d16d', component.options)
    }
    module.hot.accept("./QuickStartModal.vue?vue&type=template&id=7740d16d&", function () {
      api.rerender('7740d16d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/support/QuickStartModal.vue"
export default component.exports